"use client";

import type { FC, Ref } from "react";
import { InputList } from "@huub-web/ui";

import {
  ToggleInputTemplate,
  type ToggleInputTemplateProps,
} from "../ToggleInputTemplate";

export interface InputListTemplateProps {
  inputs?: ToggleInputTemplateProps[];
}

export const InputListTemplate: FC<
  InputListTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ inputs, ref }) => (
  <InputList ref={ref} justify="center">
    {inputs?.map((props, index) => (
      <ToggleInputTemplate key={index} {...props} />
    ))}
  </InputList>
);
